import { MapPin, Navigation, Phone } from "lucide-react";
import {
    ADDRESS_FULL,
    MAPS_DIRECTIONS,
    MAPS_EMBED,
    MSG,
    PHONE_DISPLAY,
    wa,
} from "../../data/site";
import { WhatsAppIcon } from "./Icons";
import { Reveal, SectionHeader } from "./Reveal";

export const Location = () => (
    <section id="localizacao" data-testid="location-section" className="bg-white py-24 md:py-32">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            <SectionHeader
                overline="Localização"
                title="Onde estamos"
                subtitle="Atendimento no Boqueirão, em Santos — SP, com fácil acesso e estrutura preparada para você."
            />
            <div className="mt-14 grid items-stretch gap-8 lg:grid-cols-5">
                <Reveal className="lg:col-span-2">
                    <div className="flex h-full flex-col rounded-3xl border border-slate-200/80 bg-[#FAFCFF] p-8 md:p-10">
                        <p className="font-heading text-lg font-bold text-slate-900">
                            Dr. Gabriel Riccio — Endodontista
                        </p>
                        <div className="mt-6 space-y-5">
                            <div className="flex items-start gap-3.5">
                                <span className="mt-0.5 flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-[#EFF5FF] text-[#1A6AFF]">
                                    <MapPin className="h-5 w-5" />
                                </span>
                                <p className="text-sm leading-relaxed text-slate-600" data-testid="location-address">
                                    {ADDRESS_FULL}
                                </p>
                            </div>
                            <div className="flex items-start gap-3.5">
                                <span className="mt-0.5 flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-[#EFF5FF] text-[#1A6AFF]">
                                    <Phone className="h-5 w-5" />
                                </span>
                                <p className="text-sm leading-relaxed text-slate-600" data-testid="location-phone">
                                    Telefone e WhatsApp:
                                    <br />
                                    <span className="font-semibold text-slate-900">{PHONE_DISPLAY}</span>
                                </p>
                            </div>
                        </div>
                        <div className="mt-auto flex flex-col gap-3 pt-10 sm:flex-row lg:flex-col">
                            <a
                                href={MAPS_DIRECTIONS}
                                target="_blank"
                                rel="noopener noreferrer"
                                data-testid="location-directions-button"
                                className="inline-flex flex-1 items-center justify-center gap-2 rounded-full bg-[#1A6AFF] px-6 py-3.5 text-sm font-semibold text-white shadow-lg shadow-blue-600/20 transition-all duration-300 hover:-translate-y-0.5 hover:bg-[#0052E0]"
                            >
                                <Navigation className="h-4 w-4" />
                                Como chegar
                            </a>
                            <a
                                href={wa(MSG.consulta)}
                                target="_blank"
                                rel="noopener noreferrer"
                                data-testid="location-whatsapp-button"
                                className="inline-flex flex-1 items-center justify-center gap-2 rounded-full border border-slate-300 bg-white px-6 py-3.5 text-sm font-semibold text-slate-800 transition-all duration-300 hover:-translate-y-0.5 hover:border-[#25D366] hover:text-[#1EBE57]"
                            >
                                <WhatsAppIcon className="h-4 w-4" />
                                Falar pelo WhatsApp
                            </a>
                        </div>
                    </div>
                </Reveal>
                <Reveal delay={0.12} className="lg:col-span-3">
                    <div className="h-full min-h-[380px] overflow-hidden rounded-3xl border border-slate-200/80 shadow-sm">
                        <iframe
                            title="Mapa — Dr. Gabriel Riccio, Rua Dr. Bias Bueno, 18, Boqueirão, Santos"
                            src={MAPS_EMBED}
                            loading="lazy"
                            allowFullScreen
                            referrerPolicy="no-referrer-when-downgrade"
                            className="h-full min-h-[380px] w-full border-0"
                            data-testid="location-map"
                        />
                    </div>
                </Reveal>
            </div>
        </div>
    </section>
);
